module.exports = __webpack_public_path__ + "img/Hamburger_icon.b5098bdc.png";